"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var _default = (0, _styles.makeStyles)(function () {
  return {
    root: {},
    textMasked: {
      // We use a custom font that replaces numbers glyphs with ● so it looks "masked"
      fontFamily: 'SSNRegular, sans',
      letterSpacing: '1px'
    },
    button: {
      minWidth: 0,
      textAlign: 'right',
      visibility: 'hidden',
      width: '4.5em'
    },
    buttonVisible: {
      // visibility to keep the input width the same if it is not fullWidth
      visibility: 'visible'
    }
  };
}, {
  name: 'ssn-input'
});

exports.default = _default;
